<ng-container *ngIf="cognitoSsoUr$ | async"></ng-container>
<div id="login-page" class="primary-background">
  <div id="login-form">
    <p-card
      *ngIf="viewMode == 'VERIFY'">
      <div class="input-card-body">
        <div class="scaffold-dialog-title app-heading">{{'verify_email' | translation}}</div>
        <p>{{ 'verify_your_email_which_will_be_used_to_reset_your_password_if_you_are_ever_locked_out' | translation }}</p>

        <div
          class="flex-row flex-between flex-middle"
          style="align-items: end; margin: 20px 0px">
          <div class="flex-column-1">
            <p class="list-title">
              <strong>{{ 'email' | translation }}</strong>
            </p>
            <p>{{ userInfo.email }}</p>
          </div>
          <div class="flex-column-0 align-center">
            <app-button
              [disabled]="isRequestingVerification"
              [isProcessing]="isRequestingVerification"
              status="primary"
              *ngIf="
                !userInfo.email_verified && !verificationCode.email.codeSent
              "
              (click)="requestVerification('email')">
              {{ 'verify' | translation }}
            </app-button>
            <p class="verified" *ngIf="userInfo.email_verified">
              <span>{{ 'verified' | translation }}</span
              >&nbsp;&nbsp;<i class="fas fa-check"></i>
            </p>
          </div>
        </div>
        <div *ngIf="verificationCode.email.codeSent">
          <p>{{ 'verification_check_email' | translation }}</p>
          <p-inputgroup>
            <input
              #code="ngModel"
              [(ngModel)]="verificationCode.email.code"
              pInputText
              [placeholder]="'verification_code' | translation"
              type="text" />
            <p-inputgroup-addon>
              <app-button
                [isProcessing]="processingValidation"
                [disabled]="processingValidation"
                status="primary"
                (click)="sendVerificataion('email')">
                {{ 'submit' | translation }}
              </app-button>
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>
        <div class="button-holder">
          <app-button [disabled]="disableSave" (click)="viewMode = 'EDIT'" status="primary">
            {{ 'edit' | translation }}
          </app-button>
          &nbsp;&nbsp;
          <app-button
            [disabled]="!userInfo?.email_verified"
            status="primary"
            (click)="postVerifyContinue()">
            {{ 'continue' | translation }}
          </app-button>
        </div>
      </div>
    </p-card>

    <p-card
      *ngIf="viewMode == 'EDIT'">
      <div class="scaffold-dialog-title app-heading">{{'update_contact_information' | translation}}</div>
      <div class="input-card-body">
        <div>
          <p-inputgroup id="email-edit" *ngIf="!hasSSOEnabled">
            <label>{{ 'email' | translation }}</label>
            <input
              [disabled]="disableSave"
              [(ngModel)]="updatedData.data.email"
              pInputText
              [placeholder]="'email' | translation"
              type="text" />
          </p-inputgroup>
        </div>
        <div class="button-holder">
          <app-button [disabled]="disableSave" (click)="cancelEdit()" status="secondary">
            {{ 'cancel' | translation }}
          </app-button>
          &nbsp;&nbsp;
          <app-button
            
            (click)="saveNewContact()"
            status="primary"
            [isProcessing]="disableSave"
            [disabled]="disableSave">
            {{ 'save' | translation }}
          </app-button>
        </div>
      </div>
    </p-card>

  </div>
</div>
